<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <div class="task-screen-element change-the-blank-container"
    [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()" [disabled]="disableAVButtons"></button>
    </div>
    <div class="word-to-complete">
      <!-- tiles that spell the incomplete word will go in here
      Probably use ng-repeat to loop over letters in the target word-->
      <div class="audio-controls-container ctw-speaker-adjust">
        <button class="speaker" (click)="playTargetAudioViaSpeakerClick()" [disabled]="disableAVButtons"></button>
        <button class="snail-button" (click)="playTargetAudioViaSpeakerClickSlowed()" [disabled]="disableAVButtons"></button>
      </div>
      <div class="ctw-row">
        @for (letter of targetWord; track $index) {
          <div class="ctw-target-block"
            [class.hover]="highlightTargetTile && ($index === blankTile || ($index === targetSilentEIndex && showTargetSilentE))"
            [style.border-color]="' ' + this.interventionTaskService.highlightColor() + ' '">
            @if (!showTargetAudioSupportButtons) {
              <button class = "target-letter-audio-hidden"></button>
            }
            @if (showTargetAudioSupportButtons) {
              <button class = "target-letter-audio" [class.highlight]="($index === blankTile && highlightTargetTile)"
              (click)="playTargetLetterAudio($index)" [disabled]="disableAVButtons"></button>
            }
            <div class="ctw-target-text font-42" [class.highlight]="($index === blankTile && highlightTargetTile)">
              {{letter}}
            </div>
          </div>
        }
      </div>
    </div>
    <!-- response options on tiles will go in here (will need to separate into two sets for the different rows)
    Probably ngFor looping through the response options-->
    <div class="response-row">
      @for (response of responseOptions1; track response.text) {
        <div class="button-div">
          @if (!showResponseAudioButtons) {
            <button class = "letter-audio-hidden"></button>
          }
          @if (showResponseAudioButtons) {
            <button class = "letter-audio" (click)="playLetterAudio($index)" [disabled]="disableAVButtons"></button>
          }
          <button class="response-block  font-30" [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="disableResponseButtons" (click)="submitResponse($index)">
            {{response.text}}
          </button>
          @if (response.hasSilentE) {
            <button class="silent-e font-24" [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="disableResponseButtons" (click)="submitResponse($index)">
              e
            </button>
          }
          @if (!response.hasSilentE) {
            <button class="silent-e-hidden" ng-style="{'border-color':' ' + interventionTaskService.highlightColor() + ' '}"></button>
          }
        </div>
      }
    </div>
    <div class="response-row">
      @for (response of responseOptions2; track response.text) {
        <div class="button-div">
          @if (!showResponseAudioButtons) {
            <button class = "letter-audio-hidden"></button>
          }
          @if (showResponseAudioButtons) {
            <button class = "letter-audio" (click)="playLetterAudio(response.index)" [disabled]="disableAVButtons"></button>
          }
          <button class ="response-block  font-30" [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="disableResponseButtons" (click)="submitResponse(response.index)">
            {{response.text}}
          </button>
          @if (response.hasSilentE) {
            <button class="silent-e font-24" [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="disableResponseButtons" (click)="submitResponse(response.index)">
              e
            </button>
          }
          @if (!response.hasSilentE) {
            <button class="silent-e-hidden" [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"></button>
          }
        </div>
      }
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
